import { fetchInstructions } from '@/services/instructions'

/**
 * Mutation types of the store
 */
const mutationTypes = {
  FETCHED_INSTRUCTIONS: 'FETCHED_INSTRUCTIONS',
  FETCHING_INSTRUCTIONS: 'FETCHING_INSTRUCTIONS',
  HIDE_INSTRUCTIONS: 'HIDE_INSTRUCTIONS',
  SHOW_INSTRUCTIONS: 'SHOW_INSTRUCTIONS'
}

/**
 * Initial state
 */

const defaultState = {
  instructionKey: undefined,
  instructionSection: undefined,
  filteredSections: [],
  instruction: undefined,
  show: false,
  fetching: false
}

const state = {
  ...defaultState
}

/**
 * Getters
 */
const getters = {}

/**
 * Actions
 */
const actions = {
  showInstructions(
    { commit, state },
    { instructionKey, instructionSection, filteredSections }
  ) {
    if (instructionKey === state.instructionKey) {
      commit(mutationTypes.SHOW_INSTRUCTIONS, {
        instructionKey,
        instructionSection
      })
      return
    }
    commit(mutationTypes.FETCHING_INSTRUCTIONS)

    return fetchInstructions(instructionKey)
      .then((response) => {
        commit(mutationTypes.FETCHED_INSTRUCTIONS, {
          instructionKey,
          instructionSection,
          filteredSections,
          instruction: response
        })
      })
      .catch(() => {
        commit(mutationTypes.FETCHED_INSTRUCTIONS, {
          instructionKey,
          instructionSection,
          filteredSections: [],
          instruction: undefined
        })
      })
  },

  hideInstructions({ commit }) {
    commit(mutationTypes.HIDE_INSTRUCTIONS)
  }
}

/**
 * Mutations
 */
const mutations = {
  [mutationTypes.FETCHING_INSTRUCTIONS](state) {
    state.fetching = true
    state.show = true
  },

  [mutationTypes.FETCHED_INSTRUCTIONS](
    state,
    { instructionKey, instructionSection, filteredSections, instruction }
  ) {
    state.instructionKey = instructionKey
    state.instructionSection = instructionSection
    state.filteredSections = filteredSections || []
    // Remove any sections that were requested to be filtered!
    if (instruction && filteredSections && filteredSections.length > 0) {
      instruction.sections = instruction.sections.filter(
        (s) => !filteredSections.includes(s.title)
      )
    }
    state.instruction = instruction
    state.fetching = false
  },

  [mutationTypes.SHOW_INSTRUCTIONS](
    state,
    { instructionKey, instructionSection }
  ) {
    state.show = true
    state.instructionKey = instructionKey
    state.instructionSection = instructionSection
  },

  [mutationTypes.HIDE_INSTRUCTIONS](state) {
    state.show = false
  }
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}
